/* Kanela 22.10.2026: «Überraschen Sie mich». Füllt den Warenkorb mit 1 bis 6 Artikeln bis zum Gratis-Versand,
   höchstens CHF 10 darüber (Warenkorb bis CHF 110). Reihenfolge: früher gekaufte Artikel (angemeldete Kunden, länger nicht gekauft),
   passend zum Warenkorb (gleiche Marke), Kollektion «ueberrasch-mich» und Alltags-Kollektionen (Taschentücher, Zahnpflege, Lippenbalsam usw.).
   Erscheint ab 1 Artikel im Warenkorb, solange noch mindestens CHF 5 bis zum Gratis-Versand fehlen. «Rückgängig» entfernt die Überraschung wieder.
   Kanela 22.10.2026, Stufe 1: Suchbegriffe und angesehene Produkte dieser Sitzung (nur im Browser des Kunden) werden bevorzugt.
   Kanela 22.10.2026, Stufe 2: Bewertung je Artikel aus dem Shop-Metafeld kanela.ueberraschung_bewertung (wöchentlich aus den Bestellungen berechnet).
   Kanela 22.10.2026, Tracking: Ereignisse an Google Analytics 4, Microsoft Clarity und Shopify-Kundenereignisse,
   dazu das Warenkorb-Attribut _kel_ueberraschung (Klicks, Mischen, Rückgängig, Sekunden, weggemischte Artikel), das in der Bestellung landet.
   Kanela 23.10.2026: Einzelne Überraschungsartikel tauschen. Freigestelltes Mischen-Symbol unter dem X jeder Überraschungszeile,
   tauscht nur diesen Artikel. Einmal kurze Drehung und einmal pro Sitzung der Hinweis «Artikel tauschen».
   Kanela 23.10.2026, Regel Tauschen: genau 1 Artikel gegen 1 Artikel, gleiche Menge, Stückpreis gleich bis 20 % höher, nie günstiger;
   ähnliche Artikel (Shopify-Empfehlungen zum ersetzten Artikel) zuerst. Warenkorb überall höchstens CHF 110.
   Kanela 23.10.2026, Version 3: Preisrahmen bleibt am ursprünglichen Überraschungsartikel der Zeile hängen (kein Hochschaukeln,
   beliebig oft tauschbar), der Ersatz erscheint an derselben Stelle, Gratis-Versand bleibt immer erhalten, nur ein Tausch gleichzeitig.
   Kanela 04.11.2026, Version 4 (Fehlerbehebung):
   - Eine Sperre für alle Aktionen (Starten, Neu mischen, Rückgängig, Tauschen) über alle Warenkorb-Elemente hinweg.
     Vorher konnte ein zweiter Klick während des Mischens eine zweite Überraschung dazulegen (Warenkorb über CHF 200)
     und der Kasten verschwand danach.
   - Die Überraschungsartikel werden aus dem Warenkorb selbst erkannt (Merkmal _kel_ueberraschung), nicht nur aus dem Browser-Speicher.
     So bleibt «Neu mischen» und «Rückgängig» immer sichtbar, solange Überraschungsartikel im Warenkorb liegen.
   - Neu mischen und Rückgängig lesen den Warenkorb frisch und brechen ab, wenn das Entfernen nicht klappt. Es wird nur dazugelegt,
     wenn noch mindestens CHF 5 bis zum Gratis-Versand fehlen.
   - Ist ein Artikel inzwischen ausverkauft, wird bis zu 2 Mal eine andere Auswahl versucht.
   - Schneller: Der Warenkorb kommt direkt mit der Seite (data-kel-cart), der Kasten erscheint sofort ohne Warten auf cart.js.
     Produktlisten werden 10 Minuten im Browser gemerkt und beim Darüberfahren oder Antippen schon vorgeladen.
   Kanela 05.11.2026, Version 5: Weihnachtswichtel hervorheben. Bei etwa jeder 3. Überraschung kommt ein Kanela Weihnachtswichtel
   (Plüschfigur 27 cm, CHF 9.90) mit hinein, abwechselnd rot und pink. Nur wenn er ins Budget passt (Warenkorb CHF 100 bis 110)
   und solange er an Lager ist, ohne Enddatum. Ein Wichtel, der schon im Warenkorb liegt, wird nicht nochmals vorgeschlagen.
   Der pinke Wichtel ist von der «Baby»-Sperre ausgenommen (Etikett «Baby & Kinder Geschenke»). */
(function(){
  if (customElements.get('kel-surprise')) return;
  var MIN_GAP = 500, MAX_OVER = 1000; // erscheint ab 1 Artikel im Warenkorb bis kurz vor dem Gratis-Versand; Warenkorb höchstens CHF 10 über dem Ziel (CHF 110)
  var SWAP_UP = 1.2; // Tauschen: Ersatz höchstens 20 % teurer als der ursprüngliche Überraschungsartikel dieser Zeile, nie günstiger
  var KEL_VERSION = '2026-11-05 v5'; try { document.documentElement.setAttribute('data-kel-surprise', KEL_VERSION); } catch(e){}
  // Kanela 04.11.2026: eine Sperre für alle Aktionen, gilt auch für neu aufgebaute Warenkorb-Elemente (löst sich spätestens nach 25 Sekunden)
  var LOCK = 0;
  function locked(){ return LOCK && Date.now() - LOCK < 25000; }
  function lock(){ if (locked()) return false; LOCK = Date.now(); return true; }
  function unlock(){ LOCK = 0; }
  var SEEN_KEY = 'kelSurpriseSeen'; // bereits gezeigte Überraschungen, damit beim nächsten Würfeln etwas anderes kommt
  var MEM = {}; // Rückfall, falls der Browser (z. B. privater Tab auf dem Handy) keinen Speicher erlaubt
  function sget(k){ try { var v = sessionStorage.getItem(k); if (v !== null) return v; } catch(e){} return MEM.hasOwnProperty(k) ? MEM[k] : null; }
  function sset(k, v){ if (v === null) delete MEM[k]; else MEM[k] = v; try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch(e){} }
  function readSeen(){ try { return JSON.parse(sget(SEEN_KEY) || '[]'); } catch(e){ return []; } }
  function writeSeen(v){ sset(SEEN_KEY, JSON.stringify(v.slice(-80))); }
  function shuffle(a){ for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }
  // Alltags-Kleinkram. Die eigene Kollektion «ueberrasch-mich» ist immer dabei, dazu zufällig 6 der übrigen (einmal je Seitenaufruf gewählt).
  var POOL_FIX = 'ueberrasch-mich';
  var POOLS = ['haushaltspapier', 'taschentuecher', 'wattestaebchen', 'lippenbalsam', 'zahnbuersten-weiche-borsten', 'zahnbuersten-mittlere-borsten', 'zahnpasta', 'handcreme', 'batterien', 'bonbon', 'feuchttuecher', 'seife', 'wasserfeste-pflaster'];
  var POOL_PICK = shuffle(POOLS.slice()).slice(0, 6);
  var STATE_KEY = 'kelSurprise';
  var STAT_KEY = 'kelSurpriseStat';
  var SIG_KEY = 'kelSurpriseSignals';
  // Stufe 1: Suchbegriffe und angesehene Produkte dieser Sitzung merken (bleibt im Browser, wird nirgends gesendet)
  function readSig(){ try { var v = JSON.parse(sget(SIG_KEY) || 'null'); if (v && v.q && v.v) return v; } catch(e){} return { q: [], v: [] }; }
  function addSig(kind, val){
    val = String(val || '').trim().toLowerCase(); if (val.length < 2) return;
    var s = readSig(), list = s[kind].filter(function(x){ return x !== val; });
    var lastQ = list[list.length - 1];
    if (kind === 'q' && lastQ && (val.indexOf(lastQ) === 0 || lastQ.indexOf(val) === 0)) list.pop(); // Tippen: nur den letzten Stand behalten
    list.push(val); s[kind] = list.slice(kind === 'q' ? -5 : -12);
    sset(SIG_KEY, JSON.stringify(s));
  }
  try {
    var mP = location.pathname.match(/\/products\/([^\/?#]+)/); if (mP) addSig('v', decodeURIComponent(mP[1]));
    if (/\/search/.test(location.pathname)) { var q0 = new URLSearchParams(location.search).get('q'); if (q0) addSig('q', q0); }
    var qT; document.addEventListener('input', function(e){
      var el = e.target; if (!el || !el.matches || !el.matches('input[type="search"], input[name="q"]')) return;
      clearTimeout(qT); qT = setTimeout(function(){ if (el.value.trim().length >= 3) addSig('q', el.value); }, 1200);
    });
  } catch(e){}
  // Tracking: zählt Klicks und schreibt eine kurze Zusammenfassung in den Warenkorb (erscheint in der Bestellung)
  function track(aktion, extra){
    extra = extra || {};
    var st = null; try { st = JSON.parse(sget(STAT_KEY) || 'null'); } catch(e){}
    st = st || { t0: Date.now(), k: 0, m: 0, r: 0, w: [] };
    if (aktion === 'start') st.k++; if (aktion === 'mischen') st.m++; if (aktion === 'rueckgaengig') st.r++; if (aktion === 'tauschen') st.t = (st.t || 0) + 1;
    if (extra.weg) st.w = st.w.concat(extra.weg).slice(-30);
    st.t1 = Date.now(); sset(STAT_KEY, JSON.stringify(st));
    var data = { artikel: extra.n || 0, betrag: (extra.sum || 0) / 100, quelle: extra.quelle || '' };
    try { if (typeof window.gtag === 'function') window.gtag('event', 'kel_ueberraschung_' + aktion, data); } catch(e){}
    try { if (typeof window.clarity === 'function') window.clarity('event', 'kel_ueberraschung_' + aktion); } catch(e){}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('kel_ueberraschung_' + aktion, data); } catch(e){}
    return 'start=' + st.k + ';mischen=' + st.m + ';rueckgaengig=' + st.r + ';tauschen=' + (st.t || 0) + ';sekunden=' + Math.round((st.t1 - st.t0) / 1000) + ';weg=' + st.w.join(',');
  }
  // Kanela 23.10.2026: Tauschen, Stil und Texte direkt hier, damit nur diese Datei geändert wird
  var SWAP_TXT = { de: 'Artikel tauschen', fr: "Échanger l'article", it: 'Cambia articolo', en: 'Swap item' };
  var SWAP_NONE = { de: 'Kein passender Ersatz gefunden', fr: 'Aucun remplacement adapté', it: 'Nessuna alternativa adatta', en: 'No suitable replacement' };
  function lang(){ var l = (document.documentElement.lang || 'de').slice(0, 2).toLowerCase(); return SWAP_TXT[l] ? l : 'de'; }
  (function(){
    if (document.getElementById('kel-swap-css')) return;
    var css = document.createElement('style'); css.id = 'kel-swap-css';
    css.textContent = '.kel-swap-wrap{display:flex;flex-direction:column;align-items:center;gap:1.4rem;position:relative}'
      + '.kel-swap{position:relative;display:inline-flex;align-items:center;justify-content:center;width:3.2rem;height:3.2rem;margin:-.4rem;border:0;background:none;padding:0;color:#c2187a;cursor:pointer;-webkit-tap-highlight-color:transparent}'
      + '.kel-swap:hover{color:#a0005a}.kel-swap:focus-visible{outline:2px solid #c2187a;outline-offset:2px;border-radius:50%}'
      + '.kel-swap[disabled]{cursor:wait;opacity:.6}.kel-swap.is-busy svg{animation:kelSwapSpin .7s linear infinite}'
      + '.kel-swap.is-intro svg{animation:kelSwapIntro 1s ease-in-out 1}.kel-swap.is-none{color:#8f8aa6;animation:kelSwapShake .4s ease-in-out 1}'
      + '.kel-swap__tip{position:absolute;right:calc(100% + .6rem);top:50%;transform:translateY(-50%);white-space:nowrap;background:#2a0f5f;color:#fff;font-size:1.15rem;line-height:1;padding:.6rem .8rem;border-radius:6px;pointer-events:none;opacity:0;transition:opacity .25s ease;z-index:3}'
      + '.kel-swap__tip.is-on{opacity:1}.kel-swap__tip:after{content:"";position:absolute;left:100%;top:50%;margin-top:-5px;border:5px solid transparent;border-left-color:#2a0f5f}'
      + '.kel-surprise.is-locked button{cursor:wait}'
      + '@keyframes kelSwapSpin{to{transform:rotate(360deg)}}@keyframes kelSwapIntro{0%{transform:rotate(0)}60%{transform:rotate(360deg) scale(1.15)}100%{transform:rotate(360deg) scale(1)}}'
      + '@keyframes kelSwapShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-3px)}75%{transform:translateX(3px)}}'
      + '@media (prefers-reduced-motion:reduce){.kel-swap svg{animation:none!important}}';
    document.head.appendChild(css);
  })();
  var INTRO_UNTIL = 0, TIP_SHOWN = false; // gilt für alle Warenkorb-Elemente, auch nach dem Neuaufbau
  var SWAP = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22"/><path d="m18 2 4 4-4 4"/><path d="M2 6h1.9c1.5 0 2.9.9 3.6 2.2"/><path d="M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8"/><path d="m18 14 4 4-4 4"/></svg>';
  // Kanela 05.11.2026: Weihnachtswichtel, etwa jede 3. Überraschung, abwechselnd rot und pink
  var WICHTEL = [
    { h: 'kanela-weihnachtswichtel-plueschfigur-rot-27cm-1-stk', pid: 16515622830429, farbe: 'rot' },
    { h: 'kanela-weihnachtswichtel-plueschfigur-pink-27cm-1-stk', pid: 16515620536669, farbe: 'pink' }
  ];
  var WICHTEL_RATE = 1 / 3;
  function isWichtel(pid){ return WICHTEL.some(function(w){ return w.pid === Number(pid); }); }
  function quelleOf(items){ var q = {}; items.forEach(function(i){ q[i.src] = true; }); return Object.keys(q).join('+'); }
  var OLD_DAYS = 45;
  // Nie automatisch dazulegen
  var HARD = /erotik|kondom|gleitgel|anfangsmilch|folgemilch|babymilch|babynahrung|babybrei|säuglingsnahrung|ziegenmilch/i;
  // Bei Vorschlägen aus Empfehlungen und Kollektionen zusätzlich ausschliessen (persönliche Produkte)
  var SOFT = /inkontinenz|schwanger|ovulation|potenz|läuse|hämorrhoid|intim|arznei|medikament|rezept|baby|hörgerät/i;
  function root(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function esc(s){ return String(s).replace(/[&<>"]/g, function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[ch]; }); }
  // Kanela 04.11.2026: Produktlisten 10 Minuten merken (nur auf dieser Seite), der Warenkorb wird immer frisch gelesen
  var CACHE = {}, CACHE_MS = 600000;
  function getJSON(u, keep){
    if (keep) { var c = CACHE[u]; if (c && Date.now() - c.t < CACHE_MS) return c.p; }
    var p = fetch(u, { credentials: 'same-origin' }).then(function(r){ return r.ok ? r.json() : null; }).catch(function(){ return null; });
    if (keep) { CACHE[u] = { t: Date.now(), p: p }; p.then(function(v){ if (!v) delete CACHE[u]; }); }
    return p;
  }
  function getCart(){ return getJSON(root() + 'cart.js?kel=' + Date.now()); }
  function post(path, body){
    return fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json().catch(function(){ return null; }).then(function(j){ if (!r.ok || !j) { var e = new Error('cart ' + r.status); e.status = r.status; throw e; } return j; }); });
  }
  function readState(){ try { return JSON.parse(sget(STATE_KEY) || 'null'); } catch(e){ return null; } }
  function writeState(v){ sset(STATE_KEY, v ? JSON.stringify(v) : null); }
  // Kanela 04.11.2026: Überraschungsartikel direkt aus dem Warenkorb erkennen (Merkmal _kel_ueberraschung), Reihenfolge aus dem Speicher
  function surpriseLines(cart){
    var st = readState() || {}, ids = st.ids || [];
    var lines = ((cart && cart.items) || []).filter(function(i){ return i.properties && i.properties._kel_ueberraschung; });
    lines.sort(function(a, b){
      var x = ids.indexOf(a.variant_id), y = ids.indexOf(b.variant_id);
      return (x < 0 ? 99 : x) - (y < 0 ? 99 : y);
    });
    if (lines.length) {
      var nids = lines.map(function(l){ return l.variant_id; }), base = {};
      nids.forEach(function(id){ var l = lines.filter(function(x){ return x.variant_id === id; })[0]; base[id] = (st.base && st.base[id]) || (l && l.final_price) || 0; });
      writeState({ ids: nids, base: base });
    } else if (st.ids) writeState(null);
    return lines;
  }
  function text(p){ return [p.title, p.type || p.product_type || '', (p.tags || []).join(' ')].join(' '); }
  function variantOf(p){
    var vs = p.variants || [];
    var v = vs.filter(function(x){ return x.available; })[0];
    if (!v) return null;
    var price = typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price;
    return { id: v.id, price: price };
  }
  var DICE = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 18h1.4c1.3 0 2.5-.6 3.3-1.7l6.1-8.6c.7-1.1 2-1.7 3.3-1.7H22"/><path d="m18 2 4 4-4 4"/><path d="M2 6h1.9c1.5 0 2.9.9 3.6 2.2"/><path d="M22 18h-5.9c-1.3 0-2.6-.7-3.3-1.8l-.5-.8"/><path d="m18 14 4 4-4 4"/></svg>'; // Mischen-Pfeile
  var GIFT = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 1 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 1 0 0-5C13 2 12 7 12 7z"/></svg>';

  function publish(payload, cart){
    cart.sections = payload && payload.sections;
    if (window.FoxTheme && FoxTheme.pubsub) FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
  }

  class KelSurprise extends HTMLElement {
    connectedCallback(){
      var self = this;
      var pastEl = this.querySelector('[data-kel-past]');
      try { this.past = pastEl ? JSON.parse(pastEl.textContent) : []; } catch(e){ this.past = []; }
      var scEl = this.querySelector('[data-kel-scores]');
      try { this.scores = (scEl && JSON.parse(scEl.textContent)) || {}; } catch(e){ this.scores = {}; }
      this.drawer = this.closest('cart-drawer');
      this.sectionId = this.drawer ? this.drawer.dataset.sectionId : null;
      // Kanela 04.11.2026: sofort aus dem mitgelieferten Warenkorb zeichnen, danach still mit cart.js abgleichen
      var cEl = this.querySelector('[data-kel-cart]'), c0 = null;
      try { c0 = cEl ? JSON.parse(cEl.textContent) : null; } catch(e){ c0 = null; }
      if (c0 && c0.items) this.paint(c0);
      this.render();
      this._onUpd = function(e){
        var c = e && e.detail && e.detail.cart;
        if (c && c.items && typeof c.total_price === 'number' && !locked()) self.paint(c);
        setTimeout(function(){ if (!locked()) self.render(); }, 60);
      };
      document.addEventListener('cart:updated', this._onUpd);
      this._warm = function(){ self.warm(); };
      this.addEventListener('pointerenter', this._warm);
      this.addEventListener('touchstart', this._warm, { passive: true });
      this.addEventListener('focusin', this._warm);
    }
    disconnectedCallback(){ document.removeEventListener('cart:updated', this._onUpd); }
    goal(){ return Number(this.dataset.goal) * 100 * Number((window.Shopify && Shopify.currency && Shopify.currency.rate) || 1); }
    // Kanela 04.11.2026: Produktlisten schon beim Darüberfahren oder Antippen laden, damit der Klick schneller wirkt
    warm(){
      if (this._warmed || !this.cart || locked()) return;
      this._warmed = true;
      var g = this.gap; if (!(g > 0)) this.gap = this.goal() - this.cart.total_price;
      this.candidates().catch(function(){});
    }
    render(){
      var self = this;
      return getCart().then(function(cart){ if (cart && !locked()) self.paint(cart); return cart; });
    }
    paint(cart){
      this.cart = cart;
      var lines = surpriseLines(cart);
      if (lines.length) { this.pin(); this.paintNote(lines); return this.markLock(); }
      var gap = this.goal() - cart.total_price;
      if (!cart.items.length) sset(STAT_KEY, null);
      if (!cart.items.length || gap < MIN_GAP) { this.hidden = true; this.pin(); return; }
      this.gap = gap;
      this.pin();
      this.paintButton();
      this.markLock();
    }
    // während einer laufenden Aktion alle Knöpfe sperren, auch in einem neu aufgebauten Warenkorb
    markLock(){
      var on = locked();
      this.classList.toggle('is-locked', !!on);
      if (on) this.querySelectorAll('button').forEach(function(b){ b.disabled = true; });
    }
    // Kanela 22.10.2026: Eigene Artikel bleiben oben angeheftet, die Überraschungsartikel stehen immer unten.
    pin(){
      var st = readState(); var ids = (st && st.ids) || [];
      var scope = this.drawer || document;
      var self = this;
      function apply(){
        scope.querySelectorAll('cart-items li.cart-item').forEach(function(li){
          var idx = ids.indexOf(Number(li.dataset.variantId)), mine = idx > -1;
          li.style.order = mine ? String(1 + idx) : ''; // Überraschungen unten, getauschte Artikel an derselben Stelle
          var old = li.querySelector('.kel-swap');
          if (!mine) { if (old) old.remove(); return; }
          if (!old) self.decorate(li);
        });
      }
      apply(); setTimeout(apply, 150); setTimeout(apply, 600);
    }
    clearUi(){ Array.prototype.slice.call(this.children).forEach(function(c){ if (c.tagName !== 'SCRIPT') c.remove(); }); }
    paintButton(msg, off){
      var self = this;
      this.clearUi();
      var wrap = document.createElement('div');
      wrap.innerHTML = '<button type="button" class="kel-surprise__btn">' + GIFT + '<span><b>' + esc(this.dataset.btn) + '</b><small>' + esc(msg || this.dataset.sub) + '</small></span></button>';
      this.appendChild(wrap.firstChild);
      this.hidden = false;
      var b = this.querySelector('.kel-surprise__btn');
      if (off) b.disabled = true;
      b.addEventListener('click', function(e){ self.start(e.currentTarget); });
    }
    paintNote(lines){
      var self = this;
      this.clearUi();
      var names = lines.map(function(l){ return esc(l.product_title); }).join(', ');
      var div = document.createElement('div');
      div.className = 'kel-surprise__note';
      var rr = esc(this.dataset.reroll || 'Neu mischen');
      div.innerHTML = '<div class="kel-surprise__text">' + GIFT + '<span>' + esc(this.dataset.note) + ' ' + names + '</span></div>'
        + '<div class="kel-surprise__actions"><button type="button" class="kel-surprise__dice">' + DICE + '<span>' + rr + '</span></button><button type="button" class="kel-surprise__undo">' + esc(this.dataset.undo) + '</button></div>';
      this.appendChild(div);
      this.hidden = false;
      div.querySelector('.kel-surprise__undo').addEventListener('click', function(e){ self.undo(e.currentTarget); });
      div.querySelector('.kel-surprise__dice').addEventListener('click', function(e){ self.reroll(e.currentTarget); });
    }
    busy(btn, cls){
      this.querySelectorAll('button').forEach(function(b){ b.disabled = true; });
      this.classList.add('is-locked');
      if (btn) btn.classList.add(cls || 'is-busy');
    }
    // Aktion fertig oder abgebrochen: Sperre lösen und mit dem aktuellen Warenkorb neu zeichnen
    finish(payload, cart){
      unlock();
      this.classList.remove('is-locked');
      if (!this.sectionId && payload) { window.location.reload(); return; }
      if (payload && cart) return publish(payload, cart);
      this.render();
    }
    start(btn){
      var self = this;
      if (!lock()) return;
      this.busy(btn);
      getCart().then(function(cart){
        if (!cart) throw new Error('cart');
        self.cart = cart;
        if (surpriseLines(cart).length) return self.finish(); // liegt schon eine Überraschung drin, nichts doppelt dazulegen
        self.gap = self.goal() - cart.total_price;
        if (!cart.items.length || self.gap < MIN_GAP) return self.finish();
        return self.go(btn, false);
      }).catch(function(){ self.finish(); });
    }
    // Kanela 22.10.2026: Würfel, aktuelle Überraschung raus und gleich eine neue hinein (bereits gezeigte Artikel kommen nicht nochmals)
    // Kanela 04.11.2026: Warenkorb frisch lesen, nur bei erfolgreichem Entfernen neu dazulegen
    reroll(btn){
      var self = this;
      if (!lock()) return;
      this.busy(btn, 'is-rolling');
      getCart().then(function(cart){
        var lines = surpriseLines(cart);
        if (!lines.length) return self.finish();
        var updates = {};
        lines.forEach(function(l){ updates[l.key] = 0; });
        var body = { updates: updates, attributes: { _kel_ueberraschung: track('mischen', { weg: lines.map(function(l){ return l.product_id; }) }) } };
        if (self.sectionId) { body.sections = self.sectionId; body.sections_url = window.location.pathname; }
        return post('cart/update.js', body).then(function(payload){
          writeState(null);
          var after = payload && payload.items ? payload : null;
          return (after ? Promise.resolve(after) : getCart()).then(function(c){
            self.cart = c;
            self.gap = self.goal() - c.total_price;
            if (!c.items.length || self.gap < MIN_GAP) return self.finish(payload, c);
            return self.go(btn, payload);
          });
        });
      }).catch(function(){ self.finish(); });
    }
    // Kanela 23.10.2026: Tausch-Symbol unter dem X einer Überraschungszeile
    decorate(li){
      var self = this, x = li.querySelector('.cart-item__remove');
      if (!x) return;
      var wrap = x.parentElement && x.parentElement.classList.contains('kel-swap-wrap') ? x.parentElement : null;
      if (!wrap) { wrap = document.createElement('div'); wrap.className = 'kel-swap-wrap'; x.replaceWith(wrap); wrap.appendChild(x); }
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'kel-swap'; b.innerHTML = SWAP;
      b.setAttribute('aria-label', SWAP_TXT[lang()]); b.title = SWAP_TXT[lang()];
      wrap.appendChild(b);
      b.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); self.swap(Number(li.dataset.variantId), b); });
      // einmal drehen, wenn die Überraschung neu ist; Hinweis einmal pro Sitzung
      var intro = Date.now() < INTRO_UNTIL;
      if (intro) { b.classList.add('is-intro'); setTimeout(function(){ b.classList.remove('is-intro'); }, 1100); }
      if (intro && !sget('kelSwapTip') && !TIP_SHOWN) {
        TIP_SHOWN = true; sset('kelSwapTip', '1');
        var tip = document.createElement('span'); tip.className = 'kel-swap__tip'; tip.textContent = SWAP_TXT[lang()];
        b.appendChild(tip);
        setTimeout(function(){ tip.classList.add('is-on'); }, 700);
        setTimeout(function(){ tip.classList.remove('is-on'); setTimeout(function(){ tip.remove(); }, 300); }, 3700);
      }
    }
    swap(vid, btn){
      var self = this;
      if (!lock()) return;
      btn.disabled = true; btn.classList.add('is-busy');
      this.markLock();
      var done = function(ok){
        unlock(); self.classList.remove('is-locked');
        if (!ok) {
          self.querySelectorAll('button').forEach(function(b){ b.disabled = false; });
          btn.disabled = false; btn.classList.remove('is-busy'); btn.classList.add('is-none'); btn.title = SWAP_NONE[lang()];
          setTimeout(function(){ btn.classList.remove('is-none'); btn.title = SWAP_TXT[lang()]; }, 1600);
        }
      };
      getCart().then(function(cart){
        surpriseLines(cart);
        var line = cart && cart.items.filter(function(i){ return i.variant_id === vid && i.properties && i.properties._kel_ueberraschung; })[0];
        if (!line) return done(false);
        var goal = self.goal();
        var q = line.quantity, u = line.final_price; // Stückpreis, wie bezahlt (inkl. Aktion)
        var st0 = readState() || { ids: [] };
        var b0 = (st0.base && st0.base[vid]) || u; // Preis des ursprünglichen Überraschungsartikels dieser Zeile
        var rest = cart.total_price - u * q; // Warenkorb ohne diese Zeile
        var lo = Math.max(b0, Math.ceil((goal - rest) / q)); // nie günstiger als ursprünglich, Gratis-Versand bleibt
        var hi = Math.min(Math.floor(b0 * SWAP_UP), Math.floor((goal + MAX_OVER - rest) / q)); // höchstens 20 % teurer, Warenkorb höchstens CHF 110
        if (hi < lo) { track('tauschen_leer'); return done(false); }
        self.cart = cart;
        self.gap = hi - MAX_OVER; // Vorfilter in candidates(): nichts über dem Höchstpreis
        return self.candidates(line.product_id).then(function(list){
          var seen = readSeen();
          var ok = list.filter(function(i){ return i.price >= lo && i.price <= hi && i.id !== vid; });
          var fresh = ok.filter(function(i){ return seen.indexOf(i.pid) < 0; });
          if (!fresh.length) fresh = ok;
          if (!fresh.length) { track('tauschen_leer'); return done(false); }
          var top = Math.min.apply(null, fresh.map(function(i){ return i.prio; }));
          var best = fresh.filter(function(i){ return i.prio === top; });
          best.sort(function(a, b){ return (b.score || 0) - (a.score || 0); });
          var pool = best.slice(0, 6);
          var item = pool[Math.floor(Math.random() * pool.length)];
          writeSeen(seen.concat([item.pid]));
          var ids = st0.ids.slice(), pos = ids.indexOf(vid);
          if (pos > -1) ids[pos] = item.id; else ids.push(item.id); // gleiche Stelle wie der ersetzte Artikel
          var base = {}; ids.forEach(function(i){ base[i] = (st0.base && st0.base[i]) || 0; }); base[item.id] = b0;
          var attr = track('tauschen', { n: 1, sum: item.price * q, quelle: item.src, weg: [line.product_id] });
          var body = { items: [{ id: item.id, quantity: q, properties: { _kel_ueberraschung: 'ja', _kel_quelle: item.src } }] };
          if (self.sectionId) { body.sections = self.sectionId; body.sections_url = window.location.pathname; }
          // erst den Ersatz dazulegen, dann den alten Artikel entfernen: klappt das Dazulegen nicht, bleibt alles wie vorher
          return post('cart/add.js', body).then(function(){
            var upd = {}; upd[line.key] = 0;
            var b2 = { updates: upd, attributes: { _kel_ueberraschung: attr } };
            if (self.sectionId) { b2.sections = self.sectionId; b2.sections_url = window.location.pathname; }
            return post('cart/update.js', b2);
          }).then(function(payload){
            writeState({ ids: ids, base: base });
            var c = payload && payload.items ? payload : null;
            return (c ? Promise.resolve(c) : getCart()).then(function(cc){ done(true); self.finish(payload, cc); });
          });
        });
      }).catch(function(){ done(false); self.render(); });
    }
    candidates(rel){
      var self = this, cart = this.cart;
      var inCart = {}; cart.items.forEach(function(i){ inCart[i.product_id] = true; });
      var vendors = {}; cart.items.forEach(function(i){ if (i.vendor) vendors[i.vendor] = true; });
      var now = Date.now() / 1000;
      // A: früher gekauft, neuester Kauf je Artikel
      var last = {};
      (this.past || []).forEach(function(x){ if (!last[x.h] || x.d > last[x.h]) last[x.h] = x.d; });
      var handles = Object.keys(last).sort(function(a,b){ return last[a] - last[b]; }).slice(0, 15);
      var reqA = Promise.all(handles.map(function(h){
        return getJSON(root() + 'products/' + encodeURIComponent(h) + '.js', true).then(function(p){
          if (!p) return null;
          var old = (now - last[h]) / 86400 >= OLD_DAYS;
          return { p: p, prio: old ? 0 : 2, src: 'frueher' };
        });
      }));
      // B: passend zum Warenkorb (gleiche Marke)
      var bases = cart.items.filter(function(i){ return !(i.properties && i.properties._kel_ueberraschung); }).sort(function(a,b){ return b.final_price - a.final_price; }).slice(0, 3);
      var reqB = Promise.all(bases.map(function(b){
        return getJSON(root() + 'recommendations/products.json?product_id=' + b.product_id + '&limit=10&intent=related', true);
      })).then(function(list){
        var out = [];
        list.forEach(function(d){ ((d && d.products) || []).forEach(function(p){ if (vendors[p.vendor]) out.push({ p: p, prio: 1, src: 'marke' }); }); });
        return out;
      });
      // S: Stufe 1, angesehene Produkte und Suchbegriffe dieser Sitzung
      var sig = readSig();
      function prod(h, src){ return getJSON(root() + 'products/' + encodeURIComponent(h) + '.js', true).then(function(p){ return p ? { p: p, prio: 0, src: src } : null; }); }
      var reqS = Promise.all(sig.v.slice(-8).map(function(h){ return prod(h, 'angesehen'); }).concat(sig.q.slice(-3).map(function(q){
        return getJSON(root() + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6', true).then(function(d){
          var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          return Promise.all(ps.map(function(sp){ return prod(sp.handle, 'suche'); }));
        });
      }))).then(function(r){ var o = []; r.forEach(function(x){ (Array.isArray(x) ? x : [x]).forEach(function(y){ if (y) o.push(y); }); }); return o; });
      // C: Kleinkram-Kollektionen
      var reqC = Promise.all([POOL_FIX].concat(rel ? POOLS : POOL_PICK).map(function(h){ // Tauschen: alle Kollektionen, damit im engen Preisrahmen genug Auswahl da ist
        return getJSON(root() + 'collections/' + h + '/products.json?limit=60', true).then(function(d){
          return ((d && d.products) || []).map(function(p){ return { p: p, prio: 3, src: 'kleinkram' }; });
        });
      }));
      // R: nur beim Tauschen, ähnliche Artikel zum ersetzten Produkt
      var reqR = rel ? getJSON(root() + 'recommendations/products.json?product_id=' + rel + '&limit=10&intent=related', true).then(function(d){
        return ((d && d.products) || []).map(function(p){ return { p: p, prio: -1, src: 'aehnlich' }; });
      }) : Promise.resolve([]);
      // W: Weihnachtswichtel (nicht beim Tauschen), nur wenn an Lager und noch nicht im Warenkorb
      var reqW = rel ? Promise.resolve([]) : Promise.all(WICHTEL.map(function(w){
        return getJSON(root() + 'products/' + w.h + '.js', true).then(function(p){
          var v = p && !inCart[p.id] ? variantOf(p) : null;
          return v && v.price > 0 ? { title: p.title, pid: p.id, id: v.id, price: v.price, prio: -2, src: 'wichtel', score: 0, farbe: w.farbe } : null;
        });
      }));
      var scores = this.scores || {};
      return Promise.all([reqA, reqB, reqC, reqS, reqR, reqW]).then(function(r){
        if (!rel) self._wichtel = r[5].filter(Boolean);
        var all = [].concat(shuffle(r[4].slice()), shuffle(r[3].slice()), r[0].filter(Boolean), r[1]); r[2].forEach(function(x){ all = all.concat(shuffle(x.slice())); });
        var seen = {}, out = [];
        all.forEach(function(c){
          var p = c.p; if (!p || seen[p.id] || inCart[p.id]) return;
          var t = text(p);
          if (HARD.test(t)) return;
          if (c.prio === 3 && SOFT.test(t) && !isWichtel(p.id)) return; // gleiche Marke wie im Warenkorb oder früher gekauft: erlaubt
          if (c.prio !== 0 && c.prio !== 2 && /grösse|grösse|\bgr\.\s|\bsize\b|hüftumfang|\b(xs|s|m|l|xl|xxl)\/(s|m|l|xl|xxl)\b|\s(xs|s|m|l|xl|xxl)\s\(/i.test(p.title)) return; // Grössen nur bei früher gekauften Artikeln
          var v = variantOf(p); if (!v || v.price <= 0) return;
          if (v.price > self.gap + MAX_OVER) return;
          var sc = Number(scores[p.id]) || 0;
          if (sc <= -0.6) return; // Stufe 2: wird meistens weggemischt, nicht mehr vorschlagen
          seen[p.id] = true;
          out.push({ title: p.title, pid: p.id, id: v.id, price: v.price, prio: c.prio, src: c.src, score: sc });
        });
        // je Quelle zufällig höchstens 14 Artikel, damit jedes Mal andere Kombinationen möglich sind
        var by = {}; out.forEach(function(o){ (by[o.prio] = by[o.prio] || []).push(o); });
        var res = []; Object.keys(by).forEach(function(k){ res = res.concat(rel ? by[k] : shuffle(by[k]).slice(0, k === '3' ? 40 : 14)); });
        return res;
      });
    }
    pick(all, maxN){
      maxN = maxN || 6;
      // Würfel-Prinzip: bereits gezeigte Artikel zuerst auslassen, dann zufällig aus den besten Kombinationen wählen.
      var gap = this.gap;
      var seen = readSeen();
      var fresh = all.filter(function(i){ return seen.indexOf(i.pid) < 0; });
      function cost(items, sum){ var sc = 0; items.forEach(function(i){ sc += i.score || 0; }); return (items.length - 1) * 40 + (sum - gap) / 10 - sc * 30; } // Stufe 2: gut bewertete Artikel bevorzugen
      function combos(list){
        var res = [];
        function consider(items){
          var sum = 0, prio = 9;
          items.forEach(function(i){ sum += i.price; prio = Math.min(prio, i.prio); }); // Kanela 22.10.2026: zählt der passendste Artikel der Kombination
          if (sum < gap || sum > gap + MAX_OVER) return;
          res.push({ items: items, prio: prio, cost: cost(items, sum) });
        }
        for (var a = 0; a < list.length; a++) {
          consider([list[a]]);
          if (maxN < 2) continue;
          for (var b = a + 1; b < list.length; b++) {
            consider([list[a], list[b]]);
            if (maxN < 3) continue;
            for (var c = b + 1; c < list.length; c++) consider([list[a], list[b], list[c]]);
          }
        }
        return res;
      }
      // Kanela 22.10.2026: Reichen 3 Artikel nicht (grosse Lücke bis zum Gratis-Versand), zufällig mit bis zu 6 kleinen Artikeln auffüllen.
      function fill(list){
        var res = [], keys = {};
        var tierTop = Math.min.apply(null, list.map(function(i){ return i.prio; }).concat([9]));
        for (var t = 0; t < 400; t++) {
          var sum = 0, items = [], prio = 9;
          var best = list.filter(function(i){ return i.prio === tierTop; });
          var start = best.length ? [best[Math.floor(Math.random() * best.length)]] : [];
          start.concat(shuffle(list.filter(function(i){ return start.indexOf(i) < 0; }))).some(function(i){
            if (sum + i.price > gap + MAX_OVER) return false;
            items.push(i); sum += i.price; prio = Math.min(prio, i.prio);
            return sum >= gap || items.length >= maxN; // Kanela 05.11.2026: höchstens maxN Artikel (mit Wichtel 5 plus Wichtel)
          });
          if (sum < gap) continue;
          var key = items.map(function(i){ return i.pid; }).sort().join('-');
          if (keys[key]) continue; keys[key] = true;
          res.push({ items: items, prio: prio, cost: cost(items, sum) });
        }
        return res;
      }
      function find(list){
        var r = combos(list);
        var top = Math.min.apply(null, list.map(function(i){ return i.prio; }).concat([9]));
        if (maxN > 3 && !r.some(function(x){ return x.prio === top; })) r = r.concat(fill(list)); // passendste Quelle soll möglichst dabei sein
        return r;
      }
      var res = find(fresh);
      if (!res.length) { writeSeen([]); res = find(all); }
      if (!res.length) return null;
      // meist die beste Quelle, manchmal die nächste, damit es abwechslungsreich bleibt
      var tiers = res.map(function(r){ return r.prio; }).filter(function(v, i, a){ return a.indexOf(v) === i; }).sort();
      var tier = (tiers.length > 1 && Math.random() < 0.35) ? tiers[1] : tiers[0];
      var group = shuffle(res.filter(function(r){ return r.prio === tier; })).sort(function(x, y){ return x.cost - y.cost; }).slice(0, 12);
      var choice = group[Math.floor(Math.random() * group.length)];
      writeSeen(readSeen().concat(choice.items.map(function(i){ return i.pid; })));
      return choice.items;
    }
    // Kanela 05.11.2026: etwa jedes 3. Mal einen Weihnachtswichtel einplanen (andere Farbe als beim letzten Mal), Rest wie gewohnt auffüllen
    choose(list, failed){
      var ws = (this._wichtel || []).filter(function(w){ return !failed[w.id]; });
      if (ws.length && Math.random() < WICHTEL_RATE) {
        var last = sget('kelWichtelLast');
        var w = ws.filter(function(x){ return x.farbe !== last; })[0] || ws[0];
        var gap0 = this.gap, items = null;
        if (w.price <= gap0 + MAX_OVER) {
          if (w.price >= gap0) items = [w];
          else {
            this.gap = gap0 - w.price;
            var more = this.pick(list.filter(function(i){ return !isWichtel(i.pid); }), 5);
            this.gap = gap0;
            if (more) items = [w].concat(more);
          }
        }
        if (items) { sset('kelWichtelLast', w.farbe); return items; }
      }
      return this.pick(list.filter(function(i){ return !isWichtel(i.pid); })); // sonst ohne Wichtel, damit es bei etwa jedem 3. Mal bleibt
    }
    // Läuft nur unter der Sperre. prev: Antwort vom Entfernen beim Neu mischen (für den Neuaufbau, falls nichts dazukommt)
    go(btn, prev){
      var self = this, failed = {};
      return this.candidates().then(function(list){
        function attempt(n){
          var items = self.choose(list.filter(function(i){ return !failed[i.id]; }), failed);
          if (!items) {
            track('leer');
            unlock(); self.classList.remove('is-locked');
            if (prev && self.cart) publish(prev, self.cart);
            setTimeout(function(){ self.paintButton(self.dataset.none, true); }, 150);
            return;
          }
          var sum = 0; items.forEach(function(i){ sum += i.price; });
          if (sum > self.gap + MAX_OVER) return self.finish(prev, self.cart); // Sicherheitsnetz: nie über CHF 110
          var body = { items: items.map(function(i){ return { id: i.id, quantity: 1, properties: { _kel_ueberraschung: 'ja', _kel_quelle: i.src } }; }) };
          if (self.sectionId) { body.sections = self.sectionId; body.sections_url = window.location.pathname; }
          return post('cart/add.js', body).then(function(payload){
            var attr = track(prev ? 'neu' : 'start', { n: items.length, sum: sum, quelle: quelleOf(items) });
            var base = {}; items.forEach(function(i){ base[i.id] = i.price; });
            writeState({ ids: items.map(function(i){ return i.id; }), base: base });
            INTRO_UNTIL = Date.now() + 3000;
            post('cart/update.js', { attributes: { _kel_ueberraschung: attr } }).catch(function(){});
            return getCart().then(function(cart){ self.finish(payload, cart || self.cart); });
          }, function(err){
            // z. B. inzwischen ausverkauft: bis zu 2 Mal eine andere Auswahl versuchen
            items.forEach(function(i){ failed[i.id] = true; });
            if (n < 2 && err && err.status === 422) return attempt(n + 1);
            throw err;
          });
        }
        return attempt(0);
      }).catch(function(){
        if (prev && self.cart) return self.finish(prev, self.cart);
        self.finish();
      });
    }
    undo(btn){
      var self = this;
      if (!lock()) return;
      this.busy(btn);
      getCart().then(function(cart){
        var lines = surpriseLines(cart);
        if (!lines.length) return self.finish();
        var updates = {};
        lines.forEach(function(l){ updates[l.key] = 0; });
        var body = { updates: updates, attributes: { _kel_ueberraschung: track('rueckgaengig', { weg: lines.map(function(l){ return l.product_id; }) }) } };
        if (self.sectionId) { body.sections = self.sectionId; body.sections_url = window.location.pathname; }
        return post('cart/update.js', body).then(function(payload){
          writeState(null);
          var c = payload && payload.items ? payload : null;
          return (c ? Promise.resolve(c) : getCart()).then(function(cc){ self.finish(payload, cc); });
        });
      }).catch(function(){ self.finish(); });
    }
  }
  customElements.define('kel-surprise', KelSurprise);
})();
